import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "pt-2" };
const _hoisted_2 = { class: "button-wrapper" };
import { computed, toRefs, } from 'vue';
import { i18n } from '@/locales';
import LoadingMask from '@/components/Common/LoadingMask.vue';
import LeftContentController from '@/views/Dialog/StoreDeliveryPossibleArea/LeftContentController.vue';
import SearchResultTable from '@/views/Dialog/StoreDeliveryPossibleArea/SearchResultTable.vue';
import vuexStore from '@/vuex-store';
const lc = 'views.store_delivery_possible_area.';
export default /*@__PURE__*/ _defineComponent({
    __name: 'LeftContent',
    props: {
        isFetching: { type: Boolean, default: true },
        isError: { type: Boolean, default: false }
    },
    setup(__props) {
        const locale = {
            addAllArea: i18n.t(`${lc}add_all_area`),
        };
        const props = __props;
        const { isFetching, isError, } = toRefs(props);
        const isBtnDisabled = computed(() => !vuexStore.getters['storeDeliveryPossibleArea/finalGaiaDongLength']);
        const handleClickAddAllBtn = () => {
            vuexStore.dispatch('storeDeliveryPossibleArea/setEveryDeliveryPossibleAreaRegister');
        };
        return (_ctx, _cache) => {
            const _component_v_icon = _resolveComponent("v-icon");
            const _component_v_btn = _resolveComponent("v-btn");
            return (_openBlock(), _createElementBlock("div", null, [
                _createVNode(LoadingMask, {
                    "is-fetching": _unref(isFetching),
                    opacity: 0,
                    color: "primary",
                    size: "32"
                }, null, 8 /* PROPS */, ["is-fetching"]),
                _createElementVNode("div", null, [
                    _createVNode(LeftContentController)
                ]),
                _createElementVNode("div", _hoisted_1, [
                    _createVNode(SearchResultTable, {
                        "is-fetching": _unref(isFetching),
                        "is-error": _unref(isError)
                    }, null, 8 /* PROPS */, ["is-fetching", "is-error"])
                ]),
                _createElementVNode("div", _hoisted_2, [
                    _createVNode(_component_v_btn, {
                        class: "brg-btn primary outlined width-fill size-l",
                        disabled: isBtnDisabled.value,
                        onClick: handleClickAddAllBtn
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_icon, { small: "" }, {
                                default: _withCtx(() => _cache[0] || (_cache[0] = [
                                    _createTextVNode(" mdi-plus ")
                                ])),
                                _: 1 /* STABLE */,
                                __: [0]
                            }),
                            _createTextVNode(" " + _toDisplayString(locale.addAllArea), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["disabled"])
                ])
            ]));
        };
    }
});
